export default __webpack_public_path__ + "static/media/referFriendLogin.7e6e9882.png";